import React, { useState } from 'react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  return <section aria-label="Qu'est-ce qu'un prompt" className="bg-transparent" data-id="element-224" data-mp="3mkdfzmsnfz7t">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: '20px',
      paddingBottom: '24px'
    }} data-id="element-225" data-mp="37nmf193bufg3">
        <div className="text-center" data-id="element-226" data-mp="3cmh9576qvqfi">
          <h2 className="font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-227" data-mp="3cnikzdvl4gya">Comment ça marche ?</h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-plum/70" data-id="element-228" data-mp="2yo9dd2lg2v5x">
            C'est une <span className="font-bold text-grape" data-id="element-229" data-mp="33n2io7qkvfv0">instruction maîtresse</span>, optimisée pour les professionnels du droit.
          </p>
        </div>

        <PromptFlow data-id="element-230" data-mp="wtqnnahvs7jy" />
        <PromptDemo data-id="element-231" data-mp="11uebjnatc89y" />

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-232" data-mp="11tms1auhq101">
          <h3 className="text-center font-display text-xl font-black text-plum sm:text-2xl" data-id="element-233" data-mp="11sbpfecs6zai">Exemples de prompts</h3>
          <p className="mt-2 text-center text-sm text-plum/60" data-id="element-234" data-mp="2wgc9p44jkj2v">Remplissez les crochets rouges, copiez et ouvrez-le dans votre IA préférée.</p>

          <div role="tablist" aria-label="Exemples de prompts" className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-235" data-mp="3a6fnd6pcv4gp">
            {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-grape/40 ${active === i ? 'bg-plum text-white' : 'border border-grape/20 bg-white text-plum/70 hover:text-plum'}`} data-id="element-236" data-mp="2hitmw7bfcfy2" data-mpi={i}>
                #{sp.n} · {sp.title}
              </button>)}
          </div>

          <div className="mt-5" role="tabpanel" data-id="element-237" data-mp="9sn27mb4auwo">
            <PromptCard key={samplePrompts[active].n} prompt={samplePrompts[active]} data-id="element-238" data-mp="9rv86fx6558i" />
          </div>
        </div>
      </div>
    </section>;
}